import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  NgZone,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { WizBaseCollector } from '../../core/wiz-base-collector';
import {
  BASE_COMPONENT,
  WizBaseComponent,
} from '../../core/wiz-base-component';
import {
  WizDropItemEvent,
  WIZ_DRAGGABLE_COMPONENT,
} from './../../../directives/behavior/drag-drop/wiz-drag-drop.model';
import { IWIZ_COMPONENT } from '../../../interfaces/iwiz-component';
// import { CollectionContainerDirective } from '../../../services/collections/collection-container.directive';

@Component({
  selector: 'wiz-tile-list',
  templateUrl: './wiz-tile-list.html',
  styleUrls: ['./wiz-tile-list.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: BASE_COMPONENT, useExisting: forwardRef(() => WizTileList) },
    { provide: WizBaseComponent, useExisting: forwardRef(() => WizTileList) },
    { provide: IWIZ_COMPONENT, useExisting: forwardRef(() => WizTileList) },
    {
      provide: WIZ_DRAGGABLE_COMPONENT,
      useExisting: forwardRef(() => WizTileList),
    },
  ],
})
export class WizTileList extends WizBaseCollector {
  

  private _DEFAULT_ITEM_WIDTH: number = 145;

  /** contexte complémentaire pour les éléments de rendu */
  @Input()
  wizContext: any = null;

  /** Largeur des tiles en px */
  @Input()
  itemWidth: number = this._DEFAULT_ITEM_WIDTH;

  get itemWidthStr(): string {
    return (this.itemWidth || this._DEFAULT_ITEM_WIDTH) + 'px';
  }

  // --- Virtual Scroll ---
  @Input()
  itemHeight: number = 145; // Hauteur (px) d'une tuile, important pour le virtual scroll !

  get itemHeightStr(): string {
    return (this.itemHeight || 145) + 'px';
  }

  /** Retourne la collection entière à afficher (filtrée/triée, non paginée car virtual scroll gère la fenêtre) */
  public get itemsForDisplay(): any[] {
    return this.wizDataProvider?.getWorkedSource() || null;
  }

  /** Pour virtual scroll : clé d'identification des items */
  trackByItem(index: number, item: any) {
    return item.code; // à ajuster selon id métier de vos items
  }

  constructor(
    cdref: ChangeDetectorRef,
    public elementRef: ElementRef,
    renderer: Renderer2,
    ngZone: NgZone
  ) {
    super(cdref, elementRef, renderer, ngZone);
  }

  /** indice de départ pour la pagination (inutile avec Virtual Scroll, conservé pour compatibilité) */
  @Input()
  indice: number = 0;

  /** taille des pages (inutile avec Virtual Scroll, conservé pour compatibilité) */
  @Input()
  pageSize: number = 0;

  /** à overrider pour alimentation de la collection de travail */
  public isSelected(item: any): boolean {
    return this.wizDataProvider?.isSelected(item);
  }

  /**
   * sélection d'un item, par clic / par space
   * @param selectedItem l'item
   */
  public onItemSelect(pSelectedItem: any): void {
    this.doSelect(pSelectedItem);
  }

  onInitTileDrag(pEvent: MouseEvent, pItem: any) {
    this.dragDropContainer?.startDrag({
      target: pEvent.currentTarget,
      data: pItem,
    });
  }

  /** Fonction de contrôle sur dragOver param = item return true si drop autorisé */
  checkDragOver(_: WizDropItemEvent): boolean {
    // A surcharger au besoin
    return true;
  }

  public getUniqueIndex(row, idx, item): number {
    let res = (row+1)*(idx+1);
    // console.log('getUniqueIndex', item.code, res);
    return res;
  }
}